export default (rawPrice, currency, intl, minimumFractionDigits = 0) => {
  return intl.formatNumber(rawPrice, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits,
  });
};
